// Entry point for the build script in your package.json
import "@hotwired/turbo-rails"
import { StreamActions } from "@hotwired/turbo"
import "./controllers"

StreamActions.closePatientModal = function () {
  document.getElementById('patient_edit_dialog')?.close()
  document.dispatchEvent(
    new CustomEvent('patient:refresh', { detail: { id: this.getAttribute('target') } })
  )
}
